import { Box, createStyles, IconButton, makeStyles, Paper, Typography } from '@material-ui/core';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import EditIcon from '@material-ui/icons/Edit';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenRoundedIcon from '@material-ui/icons/LockOpenRounded';
import SolidSmallIconButton from 'Components/Buttons/SolidSmallIconButton';
import useAsyncTask from 'hooks/useAsyncTask';
import useConfirmationDialog from 'hooks/useConfirmationDialog';
import useToastMessage from 'hooks/useToastMessage';
import { PictureModel } from 'Models/Pictures/Model';
import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { TDispatch } from 'Typings/Global';
import MuiTheme from '../../MuiTheme';
import { Book } from './@types';
import { OBook } from './Model';


interface BookCardProps {
    book: Book;
    onEdit?: (book: Book) => void;
}


const BookCard: FC<BookCardProps> = (props) => {

    const classes = useStyles();
    const { book, onEdit } = props;
    const dispatch = useDispatch<TDispatch>();

    const deleteTask = useAsyncTask(async () => await dispatch(OBook.deleteItem(book.id, {}, undefined, { deletedItemId: book.id })));

    const togglePublishTask = useAsyncTask(async () => {
        await withToast(
            async () => {
                await dispatch(OBook.postActivity(OBook.Activities.TOGGLE_PUBLISH, {}, { id: book.id, publish: !book.isPublished }))
            }, { successToastMessage: `Successfully ${!book.isPublished ? 'published' : 'unpublished'}` });
    })

    const withConfirmationDialog = useConfirmationDialog();

    const withToast = useToastMessage();

    const handleDeleteBook = () => {
        withConfirmationDialog(async () => {
            await deleteTask.run();
        }, { agreeText: 'Delete', cancelText: 'Cancel', message: 'Do you want to delete this book?' }, { successToastMessage: "Delete Success" })
    }

    return (
        <Paper className={classes.root} >
            <Link to={`/dashboard/books-solutions/books/${book.id}/chapters`} >
                <img className={classes.img} src={PictureModel.getPicUrl(book._pictures?.[0])} alt={book.name} />
            </Link>
            <div className={classes.content} >
                <Link to={`/dashboard/books-solutions/books/${book.id}/chapters`} >
                    <Typography variant={'h6'} >{book.name}</Typography>
                    <Typography variant={'caption'} color={'textSecondary'} >{book.author}</Typography>
                    <Typography variant={'overline'} color={'textSecondary'} className={classes.description} >{book.description || ''}</Typography>
                </Link>
                <div className={classes.actionButtonsContainer} >
                    <Box flex={1} >
                        <IconButton size={'small'} onClick={togglePublishTask.run} >
                            {
                                book.isPublished ? <LockOpenRoundedIcon fontSize={'inherit'} /> : <LockIcon fontSize={'inherit'} />
                            }
                        </IconButton>
                    </Box>
                    <SolidSmallIconButton onClick={() => onEdit?.(book)} ><EditIcon fontSize={'small'} /></SolidSmallIconButton>
                    <SolidSmallIconButton onClick={handleDeleteBook} ><ClearRoundedIcon fontSize={'small'} /></SolidSmallIconButton>
                </div>
            </div>
        </Paper >
    )
}

const useStyles = makeStyles((theme: typeof MuiTheme) => createStyles({
    root: {
        width: 450,
        height: 200,
        display: 'flex'
    },
    img: {
        width: 140,
        height: 'auto'
    },
    content: {
        padding: '12px 16px',
        display: 'flex',
        flexDirection: 'column'
    },
    description: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 5,
        '-webkit-box-orient': 'vertical'
    },
    actionButtonsContainer: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        marginBottom: -8,
        marginRight: -4
    }
}));
export default BookCard;